export enum CREATIVE_EVENT_NAME {
  INIT = 'init',
  CHANGE_LANG = 'change-lang',
  CLOSE = 'close',
  RESIZE = 'resize',
  RENDER_START = 'render-start',
  RENDER_FINISH = 'render-finish',
  SUCCESS = 'success',
  LOADED = 'loaded',
  ATHENA_BOT_IFRAME_MSG_TYPE = 'athena-bot-iframe-msg'
}

// iframe msg data 中的 action
export enum AthenaBotIframeMsgAction {
  BOT_READY = 'BOT_READY',
  OPEN_BOT = 'OPEN_BOT',
  SEND_KEYWORD = 'SEND_KEYWORD'
}
